import dayjs from "dayjs";
export default function getAge(dob) {
  if (!dob) return null;
  let birthDate = dayjs(dob);
  let today = dayjs();
  let age = today.diff(birthDate, "years");

  return age;
}
